import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ReservationData } from './interfaces/reservation';
import { resource } from 'app/utils/resource/old';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private http: HttpClient) {}

  createReservation(reservationData: ReservationData, lang: string = 'it'): Observable<ReservationData> {
    const resourceUrl = `wsb2c://reservation/save`;
    const params: any = { lang };

    return resource(resourceUrl)
      .params(params)
      .post<ReservationData>(reservationData);
  }
}